import { render, staticRenderFns } from "./ZddProfile.vue?vue&type=template&id=2decd506&scoped=true"
import script from "./ZddProfile.vue?vue&type=script&lang=js"
export * from "./ZddProfile.vue?vue&type=script&lang=js"
import style0 from "./ZddProfile.vue?vue&type=style&index=0&id=2decd506&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2decd506",
  null
  
)

export default component.exports